<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Terms & Conditons</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Terms & Conditions</b>
      <br />
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Tnc Category" label-for="input-1">
            <vue-multiselect
              id="ajax2"
              open-direction="bottom"
              v-model="items.tnc_category"
              v-validate="'required'"
              data-vv-as="Tnc Category"
              name="tnc_category"
              :preserve-search="true"
              :options="dataTncCategory"
              placeholder="Type to search Tnc Category"
              track-by="id"
              label="name"
              class="text-capitalize"
              :loading="isLoadingTncCategory"
              :searchable="true"
              @search-change="asyncFindTncCategory"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.name }}</span>
                </div>
              </template>
            </vue-multiselect>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('tnc_category') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.title.id"
              name="title_id"
              id="input-1"
              data-vv-as="Title Bahasa"
              class="form-control"
              placeholder="Title In Bahasa Indonesia"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.title.en"
              name="title_en"
              data-vv-as="Title English"
              class="form-control"
              placeholder="Title In English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Content (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              tag-name="textarea"
              placeholder="Content in Bahasa"
              v-model="items.content.id"
              class="form-control"
              v-validate="'required'"
              name="content_id"
              data-vv-as="Content Bahasa"
              :config="editorConfig"
            ></ckeditor>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('content_id') }}</p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Content (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              tag-name="textarea"
              placeholder="Content in English"
              v-model="items.content.en"
              v-validate="'required'"
              name="content_en"
              data-vv-as="Content English"
              class="form-control"
              :config="editorConfig"
            ></ckeditor>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('content_en') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">
            Save
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
          <router-link :to="{name: 'TncContent'}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";
export default {
  mixins: [mixInCkeditor],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      loading: false,
      items: [],
      dataTncCategory: [],
      selected: "",
      isHiddenEnglish: false,
      isHiddenBahasa: false,
      options: [
        { text: "Paxel Website", value: "web" },
        { text: "User App", value: "user" },
        { text: "Hero App", value: "hero" }
      ]
    };
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", 10);
    formData.append("page", 1);
    formData.append("sort_by", "");
    formData.append("is_sort_asc", "");
    this.$store
      .dispatch("TncCategoryModule/getTncCategorys", formData)
      .then(response => {
        this.dataTncCategory = response.data.data.results;
        this.isLoadingTncCategory = false;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.isLoadingTncCategory = false;
      });
    this.$store.dispatch(
      "TncContentModule/getTncContent",
      this.$route.params.id
    );
  },
  created() {
    this.$store.watch(
      state => state.TncContentModule.tnc_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    asyncFindTncCategory(query) {
      this.isLoadingTncCategory = true;
      this.searchTermTncCategory = query;
      this.getWorksAsync();
    },
    getWorksAsync: _.debounce(function() {
      const tnc = this.searchTermTncCategory.toLowerCase();
      const formData = new FormData();
      formData.append("search_param", tnc);
      formData.append("limit", 10);
      formData.append("page", 1);
      formData.append("sort_by", "");
      formData.append("is_sort_asc", "");
      this.$store
        .dispatch("TncCategoryModule/getTncCategorys", formData)
        .then(response => {
          this.dataTncCategory = response.data.data.results;
          this.isLoadingTncCategory = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.isLoadingTncCategory = false;
        });
    }, 1000),
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Terms & Condition!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const tncData = {
                tnc_category_id: this.items.tnc_category.id,
                title: {
                  id: this.items.title.id,
                  en: this.items.title.en
                },
                content: {
                  id: this.items.content.id,
                  en: this.items.content.en
                }
              };
              this.$store
                .dispatch("TncContentModule/putTnc", {
                  id: this.$route.params.id,
                  tncData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "TncContent" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.serverError = error.response.data;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        }
      });
    }
  }
};
</script>

<style>
</style>
